import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const TopHeader = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const displayName = user.fullName || user.uname;
  const initial = (displayName || '?')[0].toUpperCase();

  return (
    <header className="h-[60px] bg-white border-b border-slate-200 flex items-center justify-between px-5 shadow-sm">
      <div className="text-slate-500 text-sm">
        Welcome back, <span className="font-semibold text-brand-deep">{displayName}</span>
      </div>

      <div className="flex items-center gap-3 relative">
        <div className="text-right hidden sm:block">
          <div className="text-sm font-medium text-slate-700">{displayName}</div>
          <div className="text-xs text-slate-400 capitalize">{user.role}</div>
        </div>
        <button
          type="button"
          onClick={() => setMenuOpen((o) => !o)}
          className="w-9 h-9 rounded-full bg-brand-gradient text-white font-bold flex items-center justify-center"
          title="Account"
        >
          {initial}
        </button>

        {menuOpen && (
          <div className="absolute right-0 top-12 z-20 w-40 bg-white border border-slate-200 rounded-md shadow-lg py-1">
            <button
              className="w-full text-left px-4 py-2 text-sm text-slate-600 hover:bg-slate-50"
              onClick={() => { setMenuOpen(false); navigate('/logout'); }}
            >
              Log out
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default TopHeader;
